import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { useFeatureFlags } from "../contexts/FeatureFlagContext";
import Loader from "./Loader";
import { useLocation, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import RedirectHandler from "../components/RedirectHandler";

const ProtectedComponent = ({ component, ...componentProps }) => {
  const { isLoading, isAuthenticated } = useAuth0();
  const currentPath = useLocation().pathname;
  // Memoize by component reference — withAuthenticationRequired returns a new function on
  // every call, so calling it in the render body causes React to see a new component type
  // each render, unmounting and remounting the page (and losing all its state).
  const Component = React.useMemo(
    () =>
      withAuthenticationRequired(component, {
        onRedirecting: () => <Loader />,
      }),
    [component] // currentPath intentionally omitted — only needed for auth redirect, not memoization
  );

  const { ajaxLoading, isPathAllowed, wrongEnvironment } = useFeatureFlags();

  if (!isAuthenticated && !isLoading) {
    sessionStorage.setItem("redirectPath", currentPath);
    return <Navigate to="/" state={{ from: currentPath }} replace />;
  }

  if (isLoading || ajaxLoading) {
    return <Loader />;
  }

  if (wrongEnvironment) {
    return <RedirectHandler />;
  }

  if (!isPathAllowed(currentPath)) {
    sessionStorage.setItem("redirectPath", currentPath);
    return <Navigate to="/" state={{ from: currentPath }} replace />;
  }

  return <Component {...componentProps} />;
};

export default ProtectedComponent;
